import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Chart } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import { ChartCardContainer, ChartCardHeader, ChartRefreshIcon } from "./ChartStyles";
import { alpha, useTheme } from "@mui/material";
import { IconButton } from "@totalsoft/rocket-ui";
import { useHistory } from "react-router-dom";

export const ClientStatusChart = ({ loadChartData, chartData, title }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const history = useHistory();

  const handleOpenPartner = useCallback(
    (_, target) => {
      const index = target?.[0]?.element?.$context?.dataIndex;
      if (!index) return;
      history.push(`/partners/${chartData.ids[index]}`);
    },
    [history, chartData]
  );

  return (
    <ChartCardContainer>
      <Chart
        type="bar"
        title={
          <ChartCardHeader>
            {title}
            <IconButton color="primary" size="tiny" variant="text" tooltip={t("Refresh")} onClick={loadChartData}>
              <ChartRefreshIcon />
            </IconButton>
          </ChartCardHeader>
        }
        data={{
          labels: chartData.labels,
          datasets: [
            {
              data: chartData.series,
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.6)
            }
          ]
        }}
        options={{
          indexAxis: "y",
          onClick: handleOpenPartner,
          plugins: {
            title: {
              display: false
            },
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function () {
                  return `${t("Dashboard.FinancedAmount")}: ${t("NUMBER", {
                    number: this.dataPoints[0]?.raw
                  })}`;
                }
              }
            }
          },
          scales: {
            x: {
              ticks: {
                minRotation: 20
              }
            }
          }
        }}
      />
    </ChartCardContainer>
  );
};

ClientStatusChart.propTypes = {
  loadChartData: PropTypes.func,
  chartData: PropTypes.object,
  title: PropTypes.string.isRequired
};

export default ClientStatusChart;
